






import { Component, Vue } from 'vue-property-decorator';
import PreviewSharedFacilityForm from '@/components/Admin/Forms/PreviewSharedFacilityForm.vue';
import SharedFacilitiesCalendarForm from '@/components/Admin/Forms/SharedFacilitiesCalendarForm.vue';

@Component({
    components: {
        PreviewSharedFacilityForm,
        SharedFacilitiesCalendarForm,
    },
})
export default class SharedFacilityFlyOut extends Vue {
    constructor() {
        super();
    }

    get flyOutMode() {
        return this.$store.getters['SharedFacilities/getFacilityFormMode'];
    }

    get flyOutComponent() {
        let formComponent = '';

        switch (this.flyOutMode) {
            case 'view':
                formComponent = 'PreviewSharedFacilityForm';
                break;
            case 'calendar':
                formComponent = 'SharedFacilitiesCalendarForm';
                break;
        }

        return formComponent;
    }
}
